<template>
  <v-app light>
    <router-view style="z-index: 10"/>
    <video allowfullscreen="true" muted="muted" autoplay="autoplay" playsinline="playsinline" loop="loop" id="videobg">
      <source :src="randomVideo" type="video/mp4">
    </video>
  </v-app>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        videosbg: ['/videobg.mp4', '/videobg2.mp4', '/videobg3.mp4']
      }
    },
    computed: {
      randomVideo () {
        const rand = Math.floor(Math.random() * 3)
        console.log(rand)
        return this.videosbg[rand]
      }
    }
  }
</script>

<style scoped>
#videobg {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  z-index: 0;
}
</style>